import React, { ReactElement } from 'react';
import { ReactComponent as LightBulb } from '../../svg/icons/lightBulb.svg';
import { ReactComponent as GoodSalesPaceIcon } from '../../svg/status/sellingGood.svg';
import { ReactComponent as BadSalesPaceIcon } from '../../svg/status/sellingBad.svg';

export function getLineStatusIcon(status: string): ReactElement {
  switch (status) {
    case 'hasTip':
      return <LightBulb />;
    case 'sellingGood':
      return <GoodSalesPaceIcon />;
    case 'sellingBad':
      return <BadSalesPaceIcon />;
    default:
      return undefined;
  }
}
